module.exports = __webpack_public_path__ + "static/media/aws-academy-graduate-aws-academy-cloud-foundations.97113895.png";